import React from "react";
import SignupForm from "../auth/components/SignupForm";

const SignupPage = () => {
  return <SignupForm />;
};

export default SignupPage;
